<template>
  <section class="form-underwriting width-700">
    <el-form
      ref="form"
      :rules="rules"
      class="form-container"
      :model="formData">
      <div class="form-item">
        <span>Position / Duties</span>
        <el-form-item
          prop="duty_id"
          :rules="rules.duty_id">
          <v-select
            v-model="formData.duty_id"
            :list="localAllOptions.duties" />
        </el-form-item>
      </div>
      <div class="form-item">
        <span>Employment Nature</span>
        <el-form-item
          prop="nature"
          :rules="rules.nature">
          <v-radio-group
            v-model="formData.nature"
            :border="true"
            :list="localAllOptions.nature"
            :disabled="isDriver" />
        </el-form-item>
      </div>
      <div class="form-item">
        <span>Nationality</span>
        <el-form-item
          prop="nationality_id"
          :rules="rules.nationality_id">
          <v-select
            v-model="formData.nationality_id"
            :list="nationalityOptions" />
        </el-form-item>
      </div>

      <div class="form-item">
        <span>Age</span>
        <el-form-item
          prop="domestic_age"
          :rules="rules.domestic_age">
          <v-select
            v-model="formData.domestic_age"
            :list="localAllOptions.domestic_age" />
        </el-form-item>
      </div>

      <div class="form-item">
        <span>Monthly Salary</span>
        <el-form-item
          prop="monthly_salary"
          :rules="rules.monthly_salary">
          <!--          :list="salaryOptions"-->
          <v-input
            v-model="formData.monthly_salary"
            append="HK$"
          />
          <!--          <v-select-->
          <!--            v-model="formData.monthly_salary"-->
          <!--            :list="salaryOptions"-->
          <!--          />-->
        </el-form-item>
      </div>
      <!-- <div class="form-item">
        <span>Date of Birth</span>
        <el-form-item
          prop="domestic_dob"
          :rules="rules.domestic_dob">
          <v-date-picker v-model="formData.domestic_dob" />
        </el-form-item>
      </div> -->
      <template v-if="!isDoula">
        <div class="form-item">
          <span>Coverage</span>
          <el-form-item
            prop="coverage_id"
            :rules="rules.coverage_id">
            <v-select
              v-model="formData.coverage_id"
              :list="coverageOptions" />
          </el-form-item>
        </div>

        <div class="form-item">
          <span>Period of Insurance</span>
          <el-form-item
            prop="period_of_cvr"
            :rules="rules.period_of_cvr">
            <v-radio-group
              v-model="formData.period_of_cvr"
              :border="true"
              :list="localAllOptions.period" />
          </el-form-item>
        </div>
        <!-- <div
          v-if="isShowPlanLevel"
          class="form-item">
          <span>Plan Level</span>
          <el-form-item
            prop="plan_tier"
          >
            <v-radio-group
              v-model="formData.plan_tier"
              :border="true"
              :list="planLevelOptions"
            />
          </el-form-item>
        </div> -->
      </template>

      <!-- <div class="form-item">
        <span>Monthly Salary</span>
        <el-form-item
          prop="monthly_salary"
          :rules="rules.monthly_salary">
          <v-input
            v-model="formData.monthly_salary"
            append="HKD" />
        </el-form-item>
      </div> -->
      <template v-if="benefitsList.length > 0">
        <h3>More Benefits</h3>
        <div class="form-item">
          <v-checkbox-group
            v-model="formData.benefits"
            :isColumn="false"
            :list="benefitsList" />
        </div>
      </template>

    </el-form>
  </section>
</template>
<script>
import MixinOptions from '@/mixins/options'
import MixinRules from '@/mixins/rules'

export default {
  name: 'FormUnderwriting',
  mixins: [MixinOptions, MixinRules],
  props: {
    form: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      formData: {
        // class_id: 21,
        // customer_id: '',
        duty_id: '',
        nature: '',
        nationality_id: '',
        domestic_age: '',
        period_of_cvr: '',
        monthly_salary: '',
        coverage_id: '',
        plan_tier: 0,
        benefits: [],
        // code: '',
        // order_by: '',
        // company: ''
      },
    }
  },

  computed: {
    localAllOptions() {
      return this.allOptions21
    },
    isShowPlanLevel(){
      const { nationality_id, coverage_id } = this.formData
      if(nationality_id == 2 || coverage_id == 1){
        return false
      }
      return true
    },
    isDoula() {
      const { duty_id } = this.formData
      const data = this.getOptionData('', duty_id, this.localAllOptions.duties)
      const { doula } = data || {}
      if(doula===1)
        this.formData.monthly_salary = 20000
      else{
        this.formData.monthly_salary = 4630
      }
      return doula === 1
    },
    isPartTime() {
      const { nature } = this.formData
      return nature === 2
    },
    isDriver() {
      const { duty_id } = this.formData
      const data = this.getOptionData('', duty_id, this.localAllOptions.duties)
      const { is_driver } = data || {}
      return !!is_driver
    },
    nationalityOptions() {
      let list = this.localAllOptions.nationality || []
      if(this.isDoula) {
        list = list.filter(item => item.doula == 1)
      }
      if(this.isPartTime) {
        list = list.filter(item => item.part_time == 1)
      }
      if(this.isDriver) {
        list = list.filter(item => item.id == 1)
      }
      return list
    },
    coverageOptions() {
      const { coverage = [] } = this.localAllOptions
      if(this.isPartTime) {
        return coverage.filter(item => item.part_time === 1)
      }
      if(this.isDriver) {
        return coverage.filter(item => item.id === 2)
      }
      return coverage
    },
    salaryOptions() {
      const { salary } = this.localAllOptions
      const { doula = [], others = [] } = salary || {}
      if(this.isDoula) {
        this.formData.monthly_salary = ''
        return doula
      }
      return others
    },
    benefitsList() {
      let benefits = this.localAllOptions.benefits || []
      if(this.isDoula || this.formData.coverage_id == 1) {
        benefits = benefits.filter(item => item.id != 1)
      }
      return benefits
    }
  },
  watch: {
    form: {
      immediate: true,
      deep: true,
      handler(val) {
        Object.keys(this.formData).some(key => {
          if(key in val) {
            this.formData[key] = val[key]
          }
        })
      }
    },
    benefitsList: {
      immediate: true,
      deep: true,
      handler(list) {
        if(!list || list.length == 0) {
          this.formData.benefits = []
        }
      }
    },
    isDriver: {
      immediate: true,
      handler(val) {
        if(val) {
          this.formData.nature = 1
        }
      }
    }
  },
  methods: {
    submitForm() {
      // 表單校驗
      this.$refs.form.validate(valid => {
        if(valid) {
          // nationality_id coverage_id
          
          let params = {
            ...this.formData,
            class_id: 21
          }
          if(this.isDoula) {
            delete params.period_of_cvr
          }
          if(!this.isShowPlanLevel){
            params.plan_tier = 0
          }
          this.$emit('getFormData', params)
        }
      })

    }
  }
}
</script>
<style lang="scss" scoped>
.form-underwriting {
  position: relative;
  // width: 700px;
}
</style>
